import type { CounterType } from '.';
import type { CounterReducerState } from './reducer';
import { getFormattedCounterNumber } from './reducer';

const getMaximalPossibleNumber = (max: number, step: number): number => {
    const modulo = max % step;

    if (modulo !== 0) {
        max -= modulo;
    }

    return max;
};

const LOWEST_POSSIBLE_VALUE = 1;
const HIGHEST_POSSIBLE_VALUE = 999999;

type GetReducerStateFromCounterPropPicks = 'quantity' | 'min' | 'max' | 'step' | 'quantityUnit';

export const getReducerStateFromCounter = (
    props: Pick<CounterType, GetReducerStateFromCounterPropPicks>
): CounterReducerState => {
    const {
        max = HIGHEST_POSSIBLE_VALUE,
        step = LOWEST_POSSIBLE_VALUE,
        min = step,
        quantity = min,
        quantityUnit
    } = props;

    return {
        formattedValue: getFormattedCounterNumber({ quantity, quantityUnit }),
        max: getMaximalPossibleNumber(max, step),
        quantity,
        min,
        step,
        quantityUnit
    };
};

type GetNextPossibleNumberPropPicks = 'quantity' | 'min' | 'max' | 'step';

export const getNextPossibleNumber = (props: Pick<CounterReducerState, GetNextPossibleNumberPropPicks>): number => {
    const { quantity, min, max, step } = props;
    let newQuantity = quantity;

    if (newQuantity < min) {
        newQuantity = min;
    }

    if (newQuantity > max) {
        newQuantity = max;
    }

    const modulo = newQuantity % step;

    if (modulo !== 0) {
        const roundUpValue = newQuantity + (step - modulo);

        if (roundUpValue <= max) {
            newQuantity = roundUpValue;
        } else {
            newQuantity -= modulo;
        }
    }

    return newQuantity;
};
